// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","sider":"Layout_sider__s--Hp","content":"Layout_content__UOgH6"};